import React, { Component } from "react";
import { withThreeSkyeGlobal } from "@threeskye/global";

export const withIsReadOnly = function (WrappedComponent) {
	return withThreeSkyeGlobal(
		class extends Component {
			constructor(props) {
				super(props);
				this.isReadOnly = this.isReadOnly.bind(this);
			}

			isReadOnly() {
				return this.props.storage.get("adviser.override");
			}

			render() {
				return <WrappedComponent {...this.props} isReadOnly={this.isReadOnly} />;
			}
		}
	);
};
